﻿import { Component, ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalComponent } from 'ng2-bs3-modal';

import { Topic } from '../shared/types/topic.type';
import { TopicService } from '../shared/services/topic.service'

@Component({
  selector: 'topic',
  templateUrl: './topic.html',
  styleUrls: ['./topic.css']
})

export class TopicComponent {

  @ViewChild('addModal')
  addModal: BsModalComponent;

  @ViewChild('editModal')
  editModal: BsModalComponent;

  @ViewChild('deleteModal')
  deleteModal: BsModalComponent;

  @ViewChild('questionExists')
  questionExists: BsModalComponent;

  @ViewChild('userchartExists')
  userchartExists: BsModalComponent;

  topics: Topic[];
  selectedTopic: Topic;

  newTopicName: string = null;
  errorMessage: string;

  constructor(public _route: ActivatedRoute, public _topicService: TopicService) { }

  ngOnInit() {
   
    this.getTopics();

  }

  getTopics() {
    this._topicService.getTopics().subscribe((data: any[]) => {
      this.topics = data;
    })
  }

  editTopic() {
    if (this.selectedTopic.TopicName != null && this.selectedTopic.TopicName != '') {
      this._topicService.postTopic(this.selectedTopic).subscribe(data => {
        this.getTopics();
        this.editModal.dismiss();
      })
    } else {
      this.errorMessage = "Topic Name is required."
    }
  }

  addTopic() {
     
      if (this.newTopicName != null) {
          var exist = this.topics.filter(t => t.TopicName.toLowerCase() == this.newTopicName.toLowerCase());
          if (exist && exist.length==0) {
              let topic = new Topic;
              topic.TopicName = this.newTopicName;

              this._topicService.postTopic(topic).subscribe(data => {
                  this.getTopics();
                  this.addModal.dismiss();
                  this.newTopicName = null;
              })
          }
          else {
              this.errorMessage = "Topic Name already exists."
          }

    } else {
      this.errorMessage = "Topic Name is required."
    }
  }

  deleteTopic() {

    this._topicService.deleteTopic(this.selectedTopic.TopicId).subscribe(data => {
      if (data == "question exists") {
        this.deleteModal.dismiss();
        this.questionExists.open();
      }
      if (data == "userchart exists") {
          this.deleteModal.dismiss();
          this.userchartExists.open();
      }
      else {
        this.deleteModal.dismiss();
        this.getTopics();
      }
    })
  }

  openAddModal() {
    this.errorMessage = "";
    this.newTopicName = "";
    this.addModal.open();
  }

  openEditModal(topic:Topic) {
    this.errorMessage = "";
    this.selectedTopic = { ...topic };
    this.editModal.open();
  }

  openDeleteModal(topic) {
    this.selectedTopic = topic;
    this.deleteModal.open();
  }

  //openBookmarkFolderModal() {
  //  this.bookmarkFolderModal.open();
  //}
  
}